const currentTime: number = new Date().getTime()

const statusUnderWarranty: string = 'Under Warranty'
const statusOutOfWarranty: string = 'Out of Warranty'
const statusUnspecified: string = 'Unspecified'

const getWarrantyStatus = (warrantyExpirationDate: Date | null): string => {
  if (warrantyExpirationDate === null) {
    return statusUnspecified
  }

  return warrantyExpirationDate.getTime() >= currentTime ? statusUnderWarranty : statusOutOfWarranty
}

export { getWarrantyStatus }
